/* eslint-disable react/prop-types */
import { Icon, IconButton, Tooltip } from "@mui/material";
import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import { estadoEvento, formatoFecha, formatoPesos, resumenBloqueo } from "../utils";

const COLOR_ESTADO = { "En curso": "uproGreen", Programado: "uproBlue", Finalizado: "secondary", Inactivo: "secondary" };

const texto = (valor, onClick, extra = {}) => (
  <SoftBox component="button" type="button" sx={{ cursor: "pointer", border: 0, padding: 0, textAlign: "left", font: "inherit", maxWidth: "100%", overflowWrap: "anywhere" }} data={valor} onClick={onClick}>
    <SoftTypography verticalAlign="text-top" variant="caption" color="dark" fontWeight="bold" {...extra}>{valor}</SoftTypography>
  </SoftBox>
);

// El badge de estado abre el menú Activo/Inactivo (onEstado), no el editor.
const getRows = (eventos, { onEditar, onMenu, onEstado, idCambiandoEstado = null }) => eventos.map((evento) => {
  const estado = estadoEvento(evento);
  const editar = () => onEditar(evento);
  const cambiando = idCambiandoEstado === String(evento.id);
  const menu = !evento.menuUniversitario ? "No"
    : evento.menuUniversitarioPrecio == null ? "Tarifa del comprador" : formatoPesos(evento.menuUniversitarioPrecio);
  return {
    id: evento.id,
    rowKey: `evento-${evento.id}`,
    type: (
      <SoftBox pl={3} mr={2} sx={{ cursor: "pointer" }} onClick={editar}>
        <Tooltip title="Evento" placement="top">
          <Icon sx={{ verticalAlign: "middle", color: getUproColor("uproGreen") }} fontSize="lg">event</Icon>
        </Tooltip>
      </SoftBox>
    ),
    nombre: texto(evento.nombre, editar, { sx: { display: "block", maxWidth: { sm: 240, lg: 320 }, overflowWrap: "anywhere" } }),
    inicio: texto(formatoFecha(evento.inicioArgentina || evento.inicio), editar),
    fin: texto(formatoFecha(evento.finArgentina || evento.fin), editar),
    estado: (
      <Tooltip title={cambiando ? "Aplicando el cambio…" : "Cambiar estado"} placement="top">
        <span>
          <SoftBox component="button" type="button" data={estado} aria-label={`Cambiar estado de ${evento.nombre}`}
            disabled={Boolean(idCambiandoEstado)} aria-busy={cambiando}
            sx={{ cursor: idCambiandoEstado ? "default" : "pointer", border: 0, padding: 0, background: "transparent", opacity: cambiando ? 0.6 : 1 }}
            onClick={(e) => onEstado(e, evento)}>
            <SoftBadge color={COLOR_ESTADO[estado]} badgeContent={cambiando ? "Guardando…" : estado} container />
          </SoftBox>
        </span>
      </Tooltip>
    ),
    menu: texto(menu, editar, { fontWeight: "regular" }),
    autogestion: texto(resumenBloqueo(evento), editar, { fontWeight: "regular" }),
    accion: (
      <SoftBox mr={2}>
        <Tooltip title="Opciones" placement="top">
          <IconButton aria-label={`Opciones de ${evento.nombre}`} size="small"
            sx={{ color: getUproColor("uproGreen") }} onClick={(e) => onMenu(e, evento)}>
            <Icon>more_vert</Icon>
          </IconButton>
        </Tooltip>
      </SoftBox>
    ),
  };
});

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "nombre", desc: "Evento", align: "left" },
  { name: "inicio", desc: "Inicio", align: "left" },
  { name: "fin", desc: "Fin", align: "left" },
  { name: "estado", desc: "Estado", align: "left", noOrder: true },
  { name: "menu", desc: "Menú universitario", align: "left", noOrder: true },
  { name: "autogestion", desc: "Autogestión", align: "left", noOrder: true },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
